import React, { useEffect } from "react";
import { makeStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";
import {
  Box,
  Button,
  Grid,
  TextField,
  Container,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip
} from "@mui/material";
import { Helmet } from "react-helmet";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import ProgrammingLang from "./ProgrammingLang";
import Applications from "./Applications";
import Tools from "./ToolsVersion";
import Notify from "./Alert";
import Validerror from "./Error";
import SystemTools from "./SystemToolsVersion";
import LinuxStorageError from "./LinuxStorageError";
import WindowStorageError from "./WindowStorageError";
import Window130StorageError from "./Window130StorageError";
import AwsLinuxStorageError from "./AwsLinuxStorageError";
import AwsWindowStorageError from "./AwsWindowStorageError";
import GcpLinuxStorageError from "./GcpLinuxStorageError";
import GcpWindowStorageError from "./GcpWindowStorageError";
import DataMissingError  from "./DataMissingError";
import ServerNameError from "./ServerNameError";

const useStyles = makeStyles((theme) => ({
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "4px 0px",
  },
}));

export default function Configurations(props) {
  const { onState, value, activeStep, handleBack, handleNext, classes } = props;      
  const classes1 = useStyles();
  const [expanded, setExpanded] = React.useState(true);
  const [errorserver, setErrorserver] = React.useState();
  const [validerroropen, setvaliderroropen] = React.useState(false);
  const [validerropen, setvaliderropen] = React.useState(false);
  const [validerropen1, setvaliderropen1] = React.useState(false);
  const [find, setfind] = React.useState(false);
  const [showErrors, setShowErrors] = React.useState(false);

  
  const [linuxstorageerroropen, setlinuxstorageerroropen] = React.useState(false);
  const [missingerroropen, setmissingerroropen] = React.useState(false);
  const [sameserveropen, setSameServeropen] = React.useState(false);
  const [windowsstorageerroropen, setwindowstorageerroropen] = React.useState(false);
  const [windows130storageerroropen, setwindow130storageerroropen] = React.useState(false);

  const [awslinuxstorageerroropen, setawslinuxstorageerroropen] = React.useState(false);
  const [gcplinuxstorageerroropen, setgcplinuxstorageerroropen] = React.useState(false);
  const [awswindowsstorageerroropen, setawswindowstorageerroropen] = React.useState(false);
  const [gcpwindowsstorageerroropen, setgcpwindowstorageerroropen] = React.useState(false);


  const [alertstate, setAlertstate] = React.useState(false);
  const [formFields, setFormFields] = React.useState([]);

  const [programmingapps, setProgrammingapps] = React.useState([]);
  const [Systemtools, setSystemtools] = React.useState([]);

  const [normalapps, setNormalapps] = React.useState([]);
  const [devopsapps, setDevopsapps] = React.useState([]);

  const [devopsport, setDevopsport] = React.useState([]);
  const [normalport, setNormalport] = React.useState([]);

  const [linuxsingleselectedapp, setLinuxsingleselectedapp] = React.useState([]);  
  const [temporary, settemporary] = React.useState([]);
  const [temporarycount, settemporarycount] = React.useState([]);

  const [instancetype, setInstancetype] = React.useState([[]]);
  const [providername, setProviderName] = React.useState([[]]);
  const [selectedOSType, setselectedOSType] = React.useState("linux");

  const handleChangeInput = (e, index) => {
    const { name, value } = e.target;
    // console.log("-----values----->", value);
    const list = [...formFields];
    if (name === "ostype"){
      setselectedOSType(value);
    }
    list[index][name] = value;
    setFormFields(list);
  };

  // const handleInstancetypeChangeInput = (e, index, selectedTitle) => {
  //   const { name, value } = e.target;
  //   const list = [...formFields];
  //   const ins_type_data = instancetype.find(instancetype => instancetype.title === value)
  //   if (selectedTitle !== undefined) {
  //     list[index]["instance_title"] = selectedTitle;
  //     list[index][name] = ins_type_data.instance_type;
  //   }
  //   setFormFields(list);
  //   // console.log("formFields", formFields);
  //  };


   const handleInstancetypeChangeInput = (e, index, selectedTitle) => {
    const { name, value } = e.target;
    const list = [...formFields];
  
    const selectedInstance = instancetype.find(item => item.title === value);
    if (selectedInstance) {
      list[index]["instance_title"] = selectedInstance.title;
      list[index][name] = selectedInstance.instance_type;
    }
  
    setFormFields(list);
  };

  const handleRemoveForm = () => {
    const lastIndex = formFields.length - 1;
    const list = [...formFields];
    list.splice(lastIndex, 1);
    setFormFields(list);
    const nameJsonStr = linuxsingleselectedapp;
    delete nameJsonStr[lastIndex];
    setLinuxsingleselectedapp(nameJsonStr);
  };

  const handleAddForm = () => {
    if (formFields.length < 5) {
      const newAddValue = {
        servername: "",
        instance_type: "",
        instance_title: "",
        ostype: "linux",
        instance_storage: "",
        port: "",
      };
      setFormFields([...formFields, newAddValue]);
    } else {
      setAlertstate(true);
    }
  };

  const handleReload = () => {
    window.location.reload();
  };

  const [checkstate, setCheckstate] = React.useState({});
  const handlecheckChange = (event) => {
    setCheckstate({ ...checkstate, [event.target.name]: event.target.checked });
  };

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/instancetype/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setInstancetype(resp))
      .catch((error) => {
        console.error(error);
      });
  }, []);

  useEffect(() => {
    const labType = "custom"
    fetch(`${process.env.REACT_APP_API_URL}/api/getproviderdetails/${labType}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setProviderName(resp))
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const handleSubmitClick = (e) => {
    setShowErrors(true);
    e.preventDefault();
      const Lengthform = formFields.length;      
      var newObj = {};
      var newObj2 = {};
      let count = 0;
      let limit = 0;
      let empty = 0;
      let verify_type = "";
      let com_1 = "";
      let com_2= "";
      let com_3 = "";
      let com_4 = "";
      let com_5 = "";
      
      let collectType = [];
      [...Array(Lengthform)].map((frm, i) => {
        collectType.push(formFields[i]["instance_type"]);
        const numberObject = i + 1;
        const server = "server-" + numberObject;
        const servername = "servername-" + numberObject;
        const instance_type = "instance_type-" + numberObject;
        const instance_title = "instance_title-" + numberObject;
        const ostype = "ostype-" + numberObject;
        const linux_type = "linux_type-" + numberObject;
        const windows_type = "windows_type-" + numberObject;
        const instance_storage = "instance_storage-" + numberObject;
        const port = "port-" + numberObject;
        const allport = "all_ports-" + numberObject;
        const command = "commands-" + numberObject;
        const appNormalValue = "apps-" + numberObject;
        const appProgrammingValue = "programming-" + numberObject;
        const appToolsValue = "tools-" + numberObject;
        const appSystemToolsValue = "system_tools-" + numberObject;

        newObj[server] = "yes";
        newObj[servername] = formFields[i]["servername"];
        newObj[instance_type] = formFields[i]["instance_type"];
        newObj[instance_title] = formFields[i]["instance_title"];
        newObj[instance_storage] = formFields[i]["instance_storage"];
        newObj[ostype] = formFields[i]["ostype"];
        if (formFields[i]["ostype"] === "linux") {
          newObj[linux_type] = formFields[i]["linux_type"];
        } else {
          newObj[windows_type] = formFields[i]["windows_type"];
        }
        
        if (formFields[i]["ostype"] === "linux") {
          verify_type = formFields[i]["linux_type"];
        } else {
          verify_type = formFields[i]["windows_type"];
        }
        
        if (typeof(verify_type) === 'undefined'){
          limit = limit + 1;
          setmissingerroropen(true);
        }
        else{
          setmissingerroropen(false);
        }

        if (formFields[i]["servername"] === '' ){
          limit = limit + 1;
          setmissingerroropen(true);
        }

        if (formFields[i]["port"] === '' ){
          limit = limit + 1;
          setmissingerroropen(true);
        }
        
        const customlistedports = formFields[i]["port"]
          .split(",")
          .map((pts) => {
            return `${pts}`;
          });
        const selectedcustomports = JSON.stringify(customlistedports).replace(
          /"/g,
          ""
        );
        if (selectedcustomports === "[all]") {
          newObj[allport] = "yes";
        } else {
          newObj[port] = selectedcustomports;
        }

        newObj2[command] = formFields[i]["command"];
        // console.log("form-fields", formFields[i]["command"])
        // console.log("new_obj2", newObj2[command])
        // console.log("i-value", i)
        if (typeof (formFields[i]["command"]) !== 'undefined') {
          if (i == 0) {
            com_1 = formFields[i]["command"].replace(/\n/g, ';');
          }
          else if (i == 1) {
            com_2 = formFields[i]["command"].replace(/\n/g, ';');
          }
          else if (i == 2) {
            com_3 = formFields[i]["command"].replace(/\n/g, ';');
          }
          else if (i == 3) {
            com_4 = formFields[i]["command"].replace(/\n/g, ';');
          }
          else if (i == 4) {
            com_4 = formFields[i]["command"].replace(/\n/g, ';');
          }
        }

        if (normalapps[i]) {
          const listofnrmlapps = normalapps[i].map((b) => {
            return `${b}`;
          });
          const selectedNormalApps = JSON.stringify(listofnrmlapps)
            .replace(/","/g, "-")
            .replace(/\[/g, "")
            .replace(/]/g, "")
            .replace(/"/g, "");
          newObj[appNormalValue] = selectedNormalApps;

          // if (devopsapps[i]) {
          //   normalport[i].map((na) => {
          //     devopsport[i].map((db) => {
          //       if (parseInt(na) === parseInt(db)) {
          //         count = count + 1;
          //         setErrorserver(`machine-${numberObject}`);
          //       }
          //     });
          //   });
          // }
        } else {
          newObj[appNormalValue] = "notapply";
        }

        const os_type = formFields[i]["ostype"];
        const inst_storage = formFields[i]["instance_storage"];
        const inst_type = formFields[i]["instance_type"]; 
        const inst_title = formFields[i]["instance_title"];  
        const windows_ttype = formFields[i]["windows_type"]  

        if (servername === "" || os_type === "" || linux_type === "" || windows_type === "" || inst_storage === "" || inst_type === "" || selectedcustomports === "") {
          empty = empty + 1;
          setmissingerroropen(true);
        }

        // if (os_type === "windows" && providername === "AZURE" && windows_ttype === "windows10" && (parseInt(inst_storage, 10) < 130)) {
        //   limit = limit + 1;
        //   setwindow130storageerroropen(true);
        // } else if (os_type === "windows" && providername === "AZURE" && windows_ttype === "windows11" && (parseInt(inst_storage, 10) < 130)) {
        //   limit = limit + 1;
        //   setwindow130storageerroropen(true);
        // }
        // else if (os_type === "windows" && providername === "AZURE" && inst_storage < 30) {
        //   limit = limit + 1;
        //   setwindowstorageerroropen(true);
        // } else if (os_type === "linux" && providername === "AZURE" && inst_storage < 30) {
        //   limit = limit + 1;
        //   setlinuxstorageerroropen(true);
        // } else if (os_type === "windows" && providername === "AWS" && inst_storage < 30) {
        //   limit = limit + 1;
        //   setawswindowstorageerroropen(true);
        // } else if (os_type === "linux" && providername === "AWS" && inst_storage < 10) {
        //   limit = limit + 1;
        //   setawslinuxstorageerroropen(true);
        // } else if (os_type === "windows" && providername === "GCP" && inst_storage < 50) {
        //   limit = limit + 1;
        //   setgcpwindowstorageerroropen(true);
        // } else if (os_type === "linux" && providername === "GCP" && inst_storage < 20) {
        //   limit = limit + 1;
        //   setgcplinuxstorageerroropen(true);
        // }               

        if (programmingapps[i]) {
          const listofprogrammingapps = programmingapps[i].map((b) => {
            return `${b}`;
          });
          const selectedProgrammingApps = JSON.stringify(listofprogrammingapps)
            .replace(/","/g, "-")
            .replace(/\[/g, "")
            .replace(/]/g, "")
            .replace(/"/g, "");
          newObj[appProgrammingValue] = selectedProgrammingApps;
        } else {
          newObj[appProgrammingValue] = "notapply";
        }

        if (devopsapps[i]) {
          const listoftools = devopsapps[i].map((b) => {
            return `${b}`;
          });
          const selectedTools = JSON.stringify(listoftools)
            .replace(/","/g, "-")
            .replace(/\[/g, "")
            .replace(/]/g, "")
            .replace(/"/g, "");
          newObj[appToolsValue] = selectedTools;
        } else {
          newObj[appToolsValue] = "notapply";
        }

        if (Systemtools[i]) {
          const listofsystemtools = Systemtools[i].map((b) => {
            return `${b}`;
          });
          const selectedSystemtools = JSON.stringify(listofsystemtools)
            .replace(/","/g, "-")
            .replace(/\[/g, "")
            .replace(/]/g, "")
            .replace(/"/g, "");
          newObj[appSystemToolsValue] = selectedSystemtools;
        } else {
          newObj[appSystemToolsValue] = "notapply";
        }
      });
            
             
      if (limit > 0) {
        setvaliderropen(true);
       }
       else if(empty > 0){
        setvaliderropen1(true);         
       } 
       else if (count > 0) {        
        setvaliderroropen(true);
       }       
        else {
          let tType = '';
          [...Array(Lengthform)].map((frm, i) => {
            if (normalapps[i]) {
              const listofnrmlapps = normalapps[i].map((b) => {
                return `${b}`;
              });
              formFields[i]["apps"] = listofnrmlapps;
            } else {
              formFields[i]["apps"] = "notapply";
            }

            if (programmingapps[i]) {
              const listofprogrammingapps = programmingapps[i].map((b) => {
                return `${b}`;
              });
              formFields[i]["programming"] = listofprogrammingapps;
            } else {
              formFields[i]["programming"] = "notapply";
            }

            if (devopsapps[i]) {
              const listoftools = devopsapps[i].map((b) => {
                return `${b}`;
              });
              formFields[i]["tools"] = listoftools;
            } else {
              formFields[i]["tools"] = "notapply";
            }

            // if (devopsapps[i]) {
            //   formFields[i]["tools"] = devopsapps[i];
            // } else {
            //   formFields[i]["tools"] = "notapply";
            // }

            if (Systemtools[i]) {
              const listofsystemtools = Systemtools[i].map((b) => {
                return `${b}`;
              });
              formFields[i]["system_tools"] = listofsystemtools;
            } else {
              formFields[i]["system_tools"] = "notapply";
            }
          });

          let cpuFinalCount = [];
          const InstanceValue = instancetype.map((instanceCpu) => {
            const CollectValue = collectType.map((collectCpu) => {
              if (instanceCpu.instance_type === collectCpu) {
                const cpuCount = instanceCpu.vCPUs;
                cpuFinalCount.push(cpuCount);
              }
            });
          });
          var addcount = cpuFinalCount.reduce(function (n, val) {
            return n + parseInt(val);
          }, 0);

          let value2 = JSON.stringify(newObj2);
          // Step 1: Extract all server names
          const serverNames = Object.keys(newObj)
          .filter(key => key.startsWith("servername-"))
          .map(key => newObj[key]);

          // Step 2: Use a Set to detect duplicates
          const uniqueServerNames = new Set();
          const duplicateServerNames = new Set();

          serverNames.forEach(name => {
            if (uniqueServerNames.has(name)) {
                duplicateServerNames.add(name);
            } else {
                uniqueServerNames.add(name);
            }
          });

          if (duplicateServerNames.size > 0) {
            // throw new Error(`Duplicate server names found: ${Array.from(duplicateServerNames).join(", ")}`);
            limit = limit + 1;
            setSameServeropen(true);
            
          }
          else {
            setSameServeropen(false);
            var value = newObj;

            for (var i = 0; i < formFields.length; i++) {
              delete formFields[i].command;
            }

            var value1 = JSON.stringify(formFields);
                              
            const id1 = "customized_variable";
            const id2 = "billing_info";
            const id3 = "commands";
            const id4 = "cpu_count";
            const id5 = "machine_count";
            const id6 = "command_1";
            const id7 = "command_2";
            const id8 = "command_3";
            const id9 = "command_4";
            const id10 = "command_5";
            
            onState((prevState) => ({
              ...prevState,
              [id1]: value,
              [id2]: value1,
              [id3]: value2,
              [id4]: addcount,
              [id5]: formFields.length,
              [id6]: com_1,
              [id7]: com_2,
              [id8]: com_3,
              [id9]: com_4,
              [id10]: com_5,
            }));

            formFields.map((rdata) => {            
              if(rdata.ostype === "windows"){
                tType = rdata.windows_type;

              } else {
                tType = rdata.linux_type;
              }
              if (
                !rdata.servername ||
                !rdata.instance_type ||
                !rdata.instance_title ||
                !rdata.ostype ||
                !rdata.instance_storage ||
                !rdata.port ||
                !tType
              )
                setmissingerroropen(true);
            });             
            handleNext();
          }
        }
  };

  const [confirmation, setconfirmation] = React.useState(false);

const handleClickConfirmation = () => {
  setShowErrors(true);
  setconfirmation(true);
};

  const handleCloseConfirmation = () => {
    setconfirmation(false);
  };

 
return (
      <React.Fragment>
        <Helmet>
          <title>LabAsService</title>
        </Helmet>
        <Box sx={{ pb: 2 }}>
          {alertstate ? <Notify setAlertstate={setAlertstate} /> : ""}
          <Container maxWidth={false}>
            
              <Validerror
                errorserver={errorserver}
                validerroropen={validerroropen}
                setvaliderroropen={setvaliderroropen}
              /> 
              <DataMissingError 
               validerropen1={missingerroropen}
               setvaliderropen1={setmissingerroropen}
              />
              <ServerNameError 
               validerropen1={sameserveropen}
               setvaliderropen1={setSameServeropen}
              />         
              <LinuxStorageError
                validerropen={linuxstorageerroropen}
                setvaliderropen={setlinuxstorageerroropen}
              />
              <WindowStorageError
                validerropen={windowsstorageerroropen}
                setvaliderropen={setwindowstorageerroropen}
              />
              <Window130StorageError
                validerropen={windows130storageerroropen}
                setvaliderropen={setwindow130storageerroropen}
              />
              <AwsLinuxStorageError
                validerropen={awslinuxstorageerroropen}
                setvaliderropen={setawslinuxstorageerroropen}
              />
              <AwsWindowStorageError
                validerropen={awswindowsstorageerroropen}
                setvaliderropen={setawswindowstorageerroropen}
              />
              <GcpLinuxStorageError
                validerropen={gcplinuxstorageerroropen}
                setvaliderropen={setgcplinuxstorageerroropen}
              />
              <GcpWindowStorageError
                validerropen={gcpwindowsstorageerroropen}
                setvaliderropen={setgcpwindowstorageerroropen}
              />                                                         
                <Box sx={{ pb: 2}}>
                  <Typography variant="h6" gutterBottom>
                    Configuration
                  </Typography>
                  
                  <div className={classes1.buttons}>
                    <Tooltip title="Add a new machine row">
                      <span>
                        <Button
                          color="primary"
                          variant="contained"
                          onClick={() => handleAddForm()}
                          size="small"
                          sx={{ borderRadius: '50px', px: 2, py: 0.5, mr: 0 }}
                        >
                          ADD
                        </Button>
                      </span>
                    </Tooltip>
                  </div>
                </Box>
                {formFields.length > 0 ? (
                  <React.Fragment>
                    <Typography variant="h6" gutterBottom>
                      {formFields.length} machines are added ( Maximum 5 machines
                      are allowed )
                    </Typography>
                    {formFields.map((e, index) => {
                      const serverIndex = index + 1;
                      return (
                        <div key={index}>
                          <Box sx={{ m: 2, border: "1px solid dark" }}>
                            <Accordion
                              style={{ border: "1px solid rgba(0, 0, 0, .125)" }}
                              defaultExpanded
                            >
                              <AccordionSummary
                                expandIcon={
                                  expanded ? (
                                    <ExpandMoreIcon />
                                  ) : (
                                    <ExpandLessIcon />
                                  )
                                }
                                onClick={(event) => {
                                  setExpanded(!expanded);
                                }}
                                aria-controls="panel1c-content"
                                id="panel1c-header"
                              >
                                <Typography variant="h6">
                                  Machine-{serverIndex}
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                <Grid container spacing={4}>
                                  <Grid item xs={6}>
          <TextField
                                      fullWidth
            helperText={
              showErrors && !e.servername
                ? 'Server name is required'
                : find
                ? "Special characters are not allowed."
                : "must be a combination of 8 lowercase letters and numbers"
            }
                                      label="Server Name"
                                      name={`servername`}
                                      id={`servername`}
            error={Boolean(showErrors && !e.servername) || Boolean(find)}
                                      onChange={(e) => {
                                        // Get the input value
                                        let inputValue = e.target.value;
                                    
                                        // Remove any non-lowercase letter or non-number characters
                                        inputValue = inputValue.replace(/[^a-z0-9]/g, '');
                                    
                                        // Limit the input to 12 characters
                                        if (inputValue.length > 8) {
                                          inputValue = inputValue.substring(0, 8);
                                        }
                                    
                                        // Update the input value
                                        e.target.value = inputValue;
                                    
                                        // Call your handleChangeInput function
                                        handleChangeInput(e, index);
                                      }}
                                      value={e.servername}
                                      required
                                      autoComplete={`servername`}
                                      onKeyPress={(e) => {
                                        const charCode = e.which || e.keyCode; // Get the character code
                                    
                                        // Allow only letters and numbers (ASCII values 48-57 for numbers, 65-90 for uppercase letters, and 97-122 for lowercase letters)
                                        if (
                                          (charCode >= 48 && charCode <= 57) || // Numbers
                                          (charCode >= 97 && charCode <= 122) // Lowercase letters
                                        ) {
                                          // Allow the character to be typed
                                        } else {
                                          e.preventDefault(); // Prevent typing special characters
                                        }
                                      }}
                                    />
                                  </Grid>
                                  <Grid item xs={6}>
                                    
                                    <TextField
                                      fullWidth
                                      label="OS-Type"
                                      name={`ostype`}
                                      id={`ostype`}
                                      onChange={(e) =>
                                        handleChangeInput(e, index)
                                      }
                                      value={e.ostype}
                                      required
                                      select
                                      SelectProps={{ native: true }}
                                      autoComplete="name"
                                      error={Boolean(showErrors && !e.ostype)}
                                      helperText={showErrors && !e.ostype ? 'OS type is required' : undefined}
                                    >
                                      {" "}
                                      <option key="linux" value="linux">
                                        Linux
                                      </option>
                                      <option key="windows" value="windows">
                                        Windows
                                      </option>
                                    </TextField>
                                  </Grid>
  
                                  <Grid item xs={6}>
                                  <TextField
                                      fullWidth
                                      label="Instance Type"
                                      name={`instance_type`}
                                      id={`instance_type`}
                                      onChange={(e) =>
                                        handleInstancetypeChangeInput(
                                          e,
                                          index,
                                          e.target.options[e.target.selectedIndex].text
                                        )
                                      }
                                      value={e.instance_title}
                                      required
                                      autoComplete="name"
                                      select
                                      SelectProps={{ native: true }}
                                    error={Boolean(showErrors && !e.instance_title)}
                                    helperText={showErrors && !e.instance_title ? 'Instance type is required' : undefined}
                                    >
                                      <option key="" value=""></option>
                                      {instancetype
                                        .filter((item) => {
                                          if (providername === "GCP" && selectedOSType === "linux"){
                                            return ["t3.small", "t3.micro", "t3.medium", "t3.large", "t3.xlarge", "t3.2xlarge"].includes(item.instance_type);
                                          }
                                          if (selectedOSType === "windows") {
                                            // Show only medium and above for Windows
                                            return ["t3.medium", "t3.large", "t3.xlarge", "t3.2xlarge"].includes(item.instance_type);
                                          }
                                          // Show all for non-Windows (Linux or others)
                                          return true;
                                        })
                                        .map((item) => (
                                          <option key={item.title} value={item.title}>
                                            {item.title}
                                          </option>
                                        ))}
                                    </TextField>
                                  </Grid>
                                  {formFields[index].ostype === "linux" ? (
                                    <React.Fragment>
                                      <Grid item xs={6}>
                                        <TextField
                                          fullWidth
                                          label="Linux-Type"
                                          name={`linux_type`}
                                          id={`linux_type`}
                                          onChange={(e) => handleChangeInput(e, index)}
                                          value={e.linux_type}
                                          required
                                          select
                                          SelectProps={{ native: true }}
                                          autoComplete="name"
                                        >
                                          <option key="" value=""></option>
                                          {providername === "AZURE" && (
                                            <>
                                              <option key="centos7" value="centos7">
                                                Centos7
                                              </option>
                                              <option key="centos8" value="centos8">
                                                Centos8
                                              </option>
                                            </>
                                          )}
                                          {providername === "AZURE" || providername === "AWS" ? (
                                            <>
                                              <option key="rocky8" value="rocky8">
                                                Rocky8
                                              </option>
                                              <option key="rocky9" value="rocky9">
                                                Rocky9
                                              </option>
                                              <option key="alma8" value="alma8">
                                                Alma8
                                              </option>
                                              <option key="alma9" value="alma9">
                                                Alma9
                                              </option>
                                              {/* <option key="ubuntu18" value="ubuntu18">
                                                Ubuntu18
                                              </option> */}
                                              <option key="ubuntu20" value="ubuntu20">
                                                Ubuntu20
                                              </option>
                                              <option key="ubuntu22" value="ubuntu22">
                                                Ubuntu22
                                              </option>
                                              <option key="ubuntu24" value="ubuntu24">
                                                Ubuntu24
                                              </option>
                                            </>
                                          ) : providername === "GCP" ? (
                                            <>
                                              <option key="rocky8" value="rocky8">
                                                Rocky8
                                              </option>
                                              <option key="rocky9" value="rocky9">
                                                Rocky9
                                              </option>
                                              <option key="alma8" value="alma8">
                                                Alma8
                                              </option>
                                              <option key="alma9" value="alma9">
                                                Alma9
                                              </option>
                                              {/* <option key="ubuntu18" value="ubuntu18">
                                                Ubuntu18
                                              </option> */}
                                              <option key="ubuntu20" value="ubuntu20">
                                                Ubuntu20
                                              </option>
                                              <option key="ubuntu22" value="ubuntu22">
                                                Ubuntu22
                                              </option>
                                              <option key="ubuntu24" value="ubuntu24">
                                                Ubuntu24
                                              </option>
                                            </>
                                          ) : null}
                                        </TextField>
                                      </Grid>
                                      {formFields[index].linux_type ===
                                      "centos7" ? (
                                        <Grid item xs={12}>
                                          <Grid container spacing={4}>
                                            <Grid item xs={6}>
                                              <Applications
                                                OSTYPE="centos7"
                                                appsetFormFields={setNormalapps}
                                                appfieldIndex={index}
                                                setNormalport={setNormalport}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <ProgrammingLang
                                                OSTYPE="centos7"
                                                appsetFormFields={
                                                  setProgrammingapps
                                                }
                                                appfieldIndex={index}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <SystemTools
                                                OSTYPE="centos7"
                                                appsetFormFields={setSystemtools}
                                                appfieldIndex={index}
                                                setNormalport={setNormalport}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <Tools
                                                OSTYPE="centos7"
                                                appsetFormFields={setDevopsapps}
                                                appfieldIndex={index}
                                                setDevopsport={setDevopsport}
                                              />
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      ) : formFields[index].linux_type ===
                                        "centos8" ? (
                                        <Grid item xs={12}>
                                          <Grid container spacing={4}>
                                            <Grid item xs={6}>
                                              <Applications
                                                OSTYPE="centos8"
                                                appsetFormFields={setNormalapps}
                                                appfieldIndex={index}
                                                setNormalport={setNormalport}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <ProgrammingLang
                                                OSTYPE="centos8"
                                                appsetFormFields={
                                                  setProgrammingapps
                                                }
                                                appfieldIndex={index}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <SystemTools
                                                OSTYPE="centos8"
                                                appsetFormFields={setSystemtools}
                                                appfieldIndex={index}
                                                setNormalport={setNormalport}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <Tools
                                                OSTYPE="centos8"
                                                appsetFormFields={setDevopsapps}
                                                appfieldIndex={index}
                                                setDevopsport={setDevopsport}
                                              />
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      ) : formFields[index].linux_type ===
                                        "ubuntu18" ? (
                                        <Grid item xs={12}>
                                          <Grid container spacing={4}>
                                            <Grid item xs={6}>
                                              <Applications
                                                OSTYPE="ubuntu18"
                                                appsetFormFields={setNormalapps}
                                                appfieldIndex={index}
                                                setNormalport={setNormalport}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <ProgrammingLang
                                                OSTYPE="ubuntu18"
                                                appsetFormFields={
                                                  setProgrammingapps
                                                }
                                                appfieldIndex={index}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <SystemTools
                                                OSTYPE="ubuntu18"
                                                appsetFormFields={setSystemtools}
                                                appfieldIndex={index}
                                                setNormalport={setNormalport}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <Tools
                                                OSTYPE="ubuntu18"
                                                appsetFormFields={setDevopsapps}
                                                appfieldIndex={index}
                                                setDevopsport={setDevopsport}
                                                // setDevopsport={setDevopsport}
                                              />
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      ) : formFields[index].linux_type ===
                                      "ubuntu20" ? (
                                        <Grid item xs={12}>
                                          <Grid container spacing={4}>
                                            <Grid item xs={6}>
                                              <Applications
                                                OSTYPE="ubuntu20"
                                                appsetFormFields={setNormalapps}
                                                appfieldIndex={index}
                                                setNormalport={setNormalport}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <ProgrammingLang
                                                OSTYPE="ubuntu20"
                                                appsetFormFields={
                                                  setProgrammingapps
                                                }
                                                appfieldIndex={index}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <SystemTools
                                                OSTYPE="ubuntu20"
                                                appsetFormFields={setSystemtools}
                                                appfieldIndex={index}
                                                setNormalport={setNormalport}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <Tools
                                                OSTYPE="ubuntu20"
                                                appsetFormFields={setDevopsapps}
                                                appfieldIndex={index}
                                                setDevopsport={setDevopsport}
                                                // setDevopsport={setDevopsport}
                                              />
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      ) : formFields[index].linux_type ===
                                      "rocky8" ? (
                                        <Grid item xs={12}>
                                          <Grid container spacing={4}>
                                            <Grid item xs={6}>
                                              <Applications
                                                OSTYPE="rocky8"
                                                appsetFormFields={setNormalapps}
                                                appfieldIndex={index}
                                                setNormalport={setNormalport}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <ProgrammingLang
                                                OSTYPE="rocky8"
                                                appsetFormFields={
                                                  setProgrammingapps
                                                }
                                                appfieldIndex={index}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <SystemTools
                                                OSTYPE="rocky8"
                                                appsetFormFields={setSystemtools}
                                                appfieldIndex={index}
                                                setNormalport={setNormalport}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <Tools
                                                OSTYPE="rocky8"
                                                appsetFormFields={setDevopsapps}
                                                appfieldIndex={index}
                                                setDevopsport={setDevopsport}
                                                // setDevopsport={setDevopsport}
                                              />
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      ) : formFields[index].linux_type ===
                                      "rocky9" ? (
                                        <Grid item xs={12}>
                                          <Grid container spacing={4}>
                                            <Grid item xs={6}>
                                              <Applications
                                                OSTYPE="rocky9"
                                                appsetFormFields={setNormalapps}
                                                appfieldIndex={index}
                                                setNormalport={setNormalport}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <ProgrammingLang
                                                OSTYPE="rocky9"
                                                appsetFormFields={
                                                  setProgrammingapps
                                                }
                                                appfieldIndex={index}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <SystemTools
                                                OSTYPE="rocky9"
                                                appsetFormFields={setSystemtools}
                                                appfieldIndex={index}
                                                setNormalport={setNormalport}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <Tools
                                                OSTYPE="rocky9"
                                                appsetFormFields={setDevopsapps}
                                                appfieldIndex={index}
                                                setDevopsport={setDevopsport}
                                                // setDevopsport={setDevopsport}
                                              />
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      ) : formFields[index].linux_type ===
                                      "alma8" ? (
                                        <Grid item xs={12}>
                                          <Grid container spacing={4}>
                                            <Grid item xs={6}>
                                              <Applications
                                                OSTYPE="alma8"
                                                appsetFormFields={setNormalapps}
                                                appfieldIndex={index}
                                                setNormalport={setNormalport}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <ProgrammingLang
                                                OSTYPE="alma8"
                                                appsetFormFields={
                                                  setProgrammingapps
                                                }
                                                appfieldIndex={index}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <SystemTools
                                                OSTYPE="alma8"
                                                appsetFormFields={setSystemtools}
                                                appfieldIndex={index}
                                                setNormalport={setNormalport}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <Tools
                                                OSTYPE="alma8"
                                                appsetFormFields={setDevopsapps}
                                                appfieldIndex={index}
                                                setDevopsport={setDevopsport}
                                                // setDevopsport={setDevopsport}
                                              />
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      ) : formFields[index].linux_type ===
                                      "alma9" ? (
                                        <Grid item xs={12}>
                                          <Grid container spacing={4}>
                                            <Grid item xs={6}>
                                              <Applications
                                                OSTYPE="alma9"
                                                appsetFormFields={setNormalapps}
                                                appfieldIndex={index}
                                                setNormalport={setNormalport}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <ProgrammingLang
                                                OSTYPE="alma9"
                                                appsetFormFields={
                                                  setProgrammingapps
                                                }
                                                appfieldIndex={index}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <SystemTools
                                                OSTYPE="alma9"
                                                appsetFormFields={setSystemtools}
                                                appfieldIndex={index}
                                                setNormalport={setNormalport}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <Tools
                                                OSTYPE="alma9"
                                                appsetFormFields={setDevopsapps}
                                                appfieldIndex={index}
                                                setDevopsport={setDevopsport}
                                                // setDevopsport={setDevopsport}
                                              />
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      ) : formFields[index].linux_type ===
                                      "ubuntu24" ? (
                                        <Grid item xs={12}>
                                          <Grid container spacing={4}>
                                            <Grid item xs={6}>
                                              <Applications
                                                OSTYPE="ubuntu24"
                                                appsetFormFields={setNormalapps}
                                                appfieldIndex={index}
                                                setNormalport={setNormalport}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <ProgrammingLang
                                                OSTYPE="ubuntu24"
                                                appsetFormFields={
                                                  setProgrammingapps
                                                }
                                                appfieldIndex={index}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <SystemTools
                                                OSTYPE="ubuntu24"
                                                appsetFormFields={setSystemtools}
                                                appfieldIndex={index}
                                                setNormalport={setNormalport}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <Tools
                                                OSTYPE="ubuntu24"
                                                appsetFormFields={setDevopsapps}
                                                appfieldIndex={index}
                                                setDevopsport={setDevopsport}
                                                // setDevopsport={setDevopsport}
                                              />
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      ) : (
                                        <Grid item xs={12}>
                                          <Grid container spacing={4}>
                                            <Grid item xs={6}>
                                              <Applications
                                                OSTYPE="ubuntu22"
                                                appsetFormFields={setNormalapps}
                                                appfieldIndex={index}
                                                setNormalport={setNormalport}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <ProgrammingLang
                                                OSTYPE="ubuntu22"
                                                appsetFormFields={
                                                  setProgrammingapps
                                                }
                                                appfieldIndex={index}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <SystemTools
                                                OSTYPE="ubuntu22"
                                                appsetFormFields={setSystemtools}
                                                appfieldIndex={index}
                                                setNormalport={setNormalport}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <Tools
                                                OSTYPE="ubuntu22"
                                                appsetFormFields={setDevopsapps}
                                                appfieldIndex={index}
                                                setDevopsport={setDevopsport}
                                                // setDevopsport={setDevopsport}
                                              />
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      )}
                                    </React.Fragment>
                                  ) : formFields[index].ostype === "windows" ? (
                                    <React.Fragment>
                                      <Grid item xs={6}>
                                        <TextField
                                          fullWidth
                                          label="Windows-Type"
                                          name={`windows_type`}
                                          id={`windows_type`}
                                          onChange={(e) =>
                                            handleChangeInput(e, index)
                                          }
                                          value={e.windows_type}
                                          required
                                          select
                                          SelectProps={{ native: true }}
                                          autoComplete="name"
                                        >
                                          {" "}
                                          <option key="" value=""></option>
                                          {providername === "AZURE" && (
                                            <>
                                              <option key="windows10" value="windows10">
                                                Windows10
                                              </option>
                                              <option key="windows11" value="windows11">
                                                Windows11
                                              </option>
                                            </>
                                          )}
                                          <option
                                            key="windows2016"
                                            value="windows2016"
                                          >
                                            Windows2016
                                          </option>
                                          <option
                                            key="windows2019"
                                            value="windows2019"
                                          >
                                            Windows2019
                                          </option>
                                          <option
                                            key="windows2022"
                                            value="windows2022"
                                          >
                                            Windows2022
                                          </option>
                                        </TextField>
                                      </Grid>
                                      {formFields[index].windows_type ===
                                      "windows2016" ? (
                                        <Grid item xs={12}>
                                          <Grid container spacing={4}>
                                            <Grid item xs={6}>
                                              <Applications
                                                OSTYPE="windows2016"
                                                appsetFormFields={setNormalapps}
                                                appfieldIndex={index}
                                                setNormalport={setNormalport}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <ProgrammingLang
                                                OSTYPE="windows2016"
                                                appsetFormFields={
                                                  setProgrammingapps
                                                }
                                                appfieldIndex={index}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <SystemTools
                                                OSTYPE="windows2016"
                                                appsetFormFields={setSystemtools}
                                                appfieldIndex={index}
                                                setNormalport={setNormalport}
                                              />
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      ) : formFields[index].windows_type ===
                                      "windows2019" ? (
                                        <Grid item xs={12}>
                                          <Grid container spacing={4}>
                                            <Grid item xs={6}>
                                              <Applications
                                                OSTYPE="windows2019"
                                                appsetFormFields={setNormalapps}
                                                appfieldIndex={index}
                                                setNormalport={setNormalport}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <ProgrammingLang
                                                OSTYPE="windows2019"
                                                appsetFormFields={
                                                  setProgrammingapps
                                                }
                                                appfieldIndex={index}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <SystemTools
                                                OSTYPE="windows2019"
                                                appsetFormFields={setSystemtools}
                                                appfieldIndex={index}
                                                setNormalport={setNormalport}
                                              />
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      ) : formFields[index].windows_type ===
                                      "windows10" ? (
                                        <Grid item xs={12}>
                                          <Grid container spacing={4}>
                                            <Grid item xs={6}>
                                              <Applications
                                                OSTYPE="windows10"
                                                appsetFormFields={setNormalapps}
                                                appfieldIndex={index}
                                                setNormalport={setNormalport}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <ProgrammingLang
                                                OSTYPE="windows10"
                                                appsetFormFields={
                                                  setProgrammingapps
                                                }
                                                appfieldIndex={index}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <SystemTools
                                                OSTYPE="windows10"
                                                appsetFormFields={setSystemtools}
                                                appfieldIndex={index}
                                                setNormalport={setNormalport}
                                              />
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      ) : formFields[index].windows_type === "windows11" ? (
                                        <Grid item xs={12}>
                                          <Grid container spacing={4}>
                                            <Grid item xs={6}>
                                              <Applications
                                                OSTYPE="windows11"
                                                appsetFormFields={setNormalapps}
                                                appfieldIndex={index}
                                                setNormalport={setNormalport}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <ProgrammingLang
                                                OSTYPE="windows11"
                                                appsetFormFields={
                                                  setProgrammingapps
                                                }
                                                appfieldIndex={index}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <SystemTools
                                                OSTYPE="windows11"
                                                appsetFormFields={setSystemtools}
                                                appfieldIndex={index}
                                                setNormalport={setNormalport}
                                              />
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      ) : (
                                        <Grid item xs={12}>
                                          <Grid container spacing={4}>
                                            <Grid item xs={6}>
                                              <Applications
                                                OSTYPE="windows2022"
                                                appsetFormFields={setNormalapps}
                                                appfieldIndex={index}
                                                setNormalport={setNormalport}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <ProgrammingLang
                                                OSTYPE="windows2022"
                                                appsetFormFields={
                                                  setProgrammingapps
                                                }
                                                appfieldIndex={index}
                                              />
                                            </Grid>
                                            <Grid item xs={6}>
                                              <SystemTools
                                                OSTYPE="windows2022"
                                                appsetFormFields={setSystemtools}
                                                appfieldIndex={index}
                                                setNormalport={setNormalport}
                                              />
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      ) }
                                    </React.Fragment>
                                  ) : (
                                    ""
                                  )}
                                  <Grid item xs={6}>
                                  <TextField
                                      fullWidth
                                      // label="Storage"
                                      name={`instance_storage`}
                                      id={`instance_storage`}
                                      onChange={(e) => handleChangeInput(e, index)}
                                      value={e.instance_storage}
                                      required
                                      select
                                      SelectProps={{ native: true }}
                                      autoComplete="name"
                                      error={Boolean(showErrors && !e.instance_storage)}
                                      helperText={showErrors && !e.instance_storage ? 'Storage is required' : undefined}
                                    >
                                      <option value="">Select Storage</option>

                                      {providername === "GCP" &&  formFields[index].ostype === "windows" && (formFields[index].windows_type !== "windows10" || formFields[index].windows_type !== "windows11") ? (
                                        <>
                                          <option key="60" value="60">60</option>
                                          <option key="125" value="125">125</option>
                                          <option key="250" value="250">250</option>
                                          <option key="500" value="500">500</option>
                                          <option key="1000" value="1000">1000</option>
                                        </>
                                      ) : formFields[index].ostype === "windows" && (formFields[index].windows_type === "windows10" || formFields[index].windows_type === "windows11") ? (
                                        <>
                                          <option key="127" value="127">127</option>
                                          <option key="250" value="250">250</option>
                                          <option key="500" value="500">500</option>
                                          <option key="1000" value="1000">1000</option>
                                        </>
                                      ) : (
                                        <>
                                          <option key="30" value="30">30</option>
                                          <option key="60" value="60">60</option>
                                          <option key="125" value="125">125</option>
                                          <option key="250" value="250">250</option>
                                          <option key="500" value="500">500</option>
                                          <option key="1000" value="1000">1000</option>
                                        </>
                                      )}
                                    </TextField>
                                  </Grid>
                                  <Grid item xs={6}>
                                    <TextField
                                      fullWidth
                                      label="Port"
                                      name={`port`}
                                      id={`port`}
                                      onChange={(e) =>
                                        handleChangeInput(e, index)
                                      }
                                      onKeyDown={(e) => {
                                        // Allow: numbers (0-9), comma, backspace, delete, tab, arrow keys
                                        const allowedKeys = [
                                          'Backspace', 'Delete', 'Tab', 
                                          'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
                                          ','
                                        ];
                                        
                                        // Get current input value
                                        const currentValue = e.target.value.toLowerCase();
                                        
                                        // Special case: allow typing "all"
                                        if (['a', 'l'].includes(e.key.toLowerCase())) {
                                          // Only allow if it's part of typing "all"
                                          if (currentValue === '' && e.key.toLowerCase() === 'a') return;
                                          if (currentValue === 'a' && e.key.toLowerCase() === 'l') return;
                                          if (currentValue === 'al' && e.key.toLowerCase() === 'l') return;
                                        }
                                        
                                        // Block if not number, comma, or allowed key
                                        if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
                                          e.preventDefault();
                                        }
                                      }}
                                      value={e.port}
                                      required
                                      autoComplete="off"
                                      error={Boolean(showErrors && (!e.port || !/^\s*(all|[0-9]+(\s*,\s*[0-9]+)*)\s*$/.test(e.port))) }
                                      helperText={
                                        showErrors && (!e.port || !/^\s*(all|[0-9]+(\s*,\s*[0-9]+)*)\s*$/.test(e.port))
                                          ? "Enter 'all' or comma-separated port numbers"
                                          : "Type 'all' to allow all ports, whereas to allow custom ports comma-separated numbers (e.g., 80,443,8080)"
                                      }
                                    />
                                  </Grid>
  
                                  <Grid item xs={12}>
                                    <TextField
                                      fullWidth
                                      label="Command"
                                      name={`command`}
                                      id={`command`}
                                      onChange={(e) =>
                                        handleChangeInput(e, index)
                                      }
                                      value={e.command}
                                      autoComplete="name"
                                      multiline
                                      rows={5}
                                    />
                                  </Grid>
                                </Grid>
                              </AccordionDetails>
                              <Divider />
                            </Accordion>
                          </Box>
                        </div>
                      );
                    })}
                    <div className={classes1.buttons}>
                      <IconButton
                        title="Delete"
                        aria-label="delete"
                        id="delete"
                        style={{
                          padding: "10px",
                          color: "#e68383",
                        }}
                      >
                        <DeleteIcon
                          color="secondary"
                          variant="contained"
                          onClick={() => handleRemoveForm()}
                        />
                      </IconButton>
                    </div>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <Box
                      sx={{
                        pb: 2,
                        pt: 2,
                        m: 2,
                        color: "#000000",
                        backgroundColor: "#e7e7e7",
                        border: "1px solid #2d5e6e",
                        bordercolor: "error.main",
                        paddingTop: 2,
                        paddingLeft: 2,
                        paddingRight: 2,
                        paddingBottom: 2,
                        textAlignLast: "center",
                      }}
                    >
                      <Typography variant="h6">
                        Click ADD button to add the servers.
                      </Typography>
                    </Box>
                  </React.Fragment>
                )}                
               
          </Container>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          pt: 2,
        }}
      >
        <div>
          <Tooltip title="Cancel and reset this step"><span>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleReload}
            className={classes}
            sx={{ borderRadius: '50px' }}
          >
            Cancel
          </Button>
          </span></Tooltip>
        </div>
        <div className={classes}>
          {activeStep !== 0 && (
            <Tooltip title="Go back to previous step"><span>
            <Button onClick={handleBack} variant="contained" color="primary" className={classes} sx={{ borderRadius: '50px', mr: 0.5 }}>
              Back
            </Button>
            </span></Tooltip>
          )}
          {checkstate.checkedB ? (
            <Tooltip title={result > 0 ? "Proceed to next step" : "Complete required fields to proceed"}><span>
            <Button
              variant="contained"
              color="primary"
              onClick={handleClickConfirmation}
              className={classes}
              disabled={result > 0 ? false : true}
              sx={{ borderRadius: '50px' }}
            >
              Next
            </Button>
            </span></Tooltip>
          ) : (
            <Tooltip title={formFields.length > 0 ? "Proceed to next step" : "Add at least one machine"}><span>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmitClick}
              className={classes}
              disabled={formFields.length > 0 ? false : true}
              sx={{ borderRadius: '50px' }}
            >
              Next
            </Button>
            </span></Tooltip>
          )}
        </div>
      </Box>
      <div style={{ alignItems: "center", display: "flex", width: "600px" }}>
        <Dialog
          open={confirmation}
          onClose={handleCloseConfirmation}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            The below applied specifications will get reflected on your machine{" "}
            <strong style={{ color: "#EF5350" }}>
              {localStorage.getItem("specifyusername")}
            </strong>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description"></DialogContentText>
          </DialogContent>
          <DialogActions>
            <Tooltip title="Close dialog"><span>
            <Button onClick={handleCloseConfirmation} color="primary" sx={{ borderRadius: '50px' }}>
              Cancel
            </Button></span></Tooltip>
            <Tooltip title="Apply configuration"><span>
            <Button onClick={handleSubmitClick} color="primary" autoFocus sx={{ borderRadius: '50px' }}>
              Apply
            </Button></span></Tooltip>
          </DialogActions>
        </Dialog>
      </div>  
  </React.Fragment>
  );
}
